module.exports = __webpack_public_path__ + "static/media/footer_tiwiter.82633138.svg";